export default "__VITE_ASSET__B84T1gA4__"